import React, { useEffect, useState } from "react";
import { Box, Text, Button } from "grommet";
import { digitalCourses } from "../../data/digitalCourses";
import { getDigitalLearner } from "../../services/getDigitalLearner";
export const DigitalLearningPath = ({ user_id, assessment_id }) => {
  const [displayedCourses, setDisplayedCourses] = useState([]);
  useEffect(() => {
    let cancelled = false;
    getDigitalLearner({ user_id, assessment_id })
      .then((response) => {
        if (cancelled || !response?.data) return;
        const flag = response.data.flag;
        let courses;
        if (flag === 1) {
          courses = digitalCourses.filter((course) => course.id === 2);
        } else if (flag === 2) {
          courses = digitalCourses.filter((course) => course.id === 2 || course.id === 3);
        } else if (flag === 3) {
          courses = [];
        } else {
          courses = digitalCourses.filter((course) => course.id === 3);
        }
        setDisplayedCourses(courses);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [user_id, assessment_id]);

  const handleCourseClick = () => {
    window.open(
      "https://education.hpe.com/ww/en/training/marketing/digital-learner-landing.html",
      "_blank",
    );
  };

  return (
    <Box pad={{ horizontal: "medium" }}>
      <Text size="large" weight="bold" margin={{ bottom: "small" }}>
        Recommended HPE Digital Learner Subscription
      </Text>
      {displayedCourses.length === 0 ? (
        <Text size="medium" margin={{ top: "small", left: "small" }}>
          We currently do not have a Digital Learner recommendation for your
          selected skill. Please check back later.
        </Text>
      ) : (
        displayedCourses.map((course) => (
          <Box
            direction="row"
            align="center"
            justify="between"
            width="full"
            pad={{ vertical: "small", horizontal: "medium" }}
            border={{ color: "brand", size: "small" }}
            background={course.color}
            margin={{ bottom: "small" }}
            round="small"
            key={course.id}
          >
            <Text>{course.title}</Text>
            <Button
              label="Learn more"
              onClick={() => handleCourseClick()}
              primary
              size="small"
            />
          </Box>
        ))
      )}
    </Box>
  );
};
